/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useSessionStore } from "../store/sessionStore";


export default function PrivateRoutes({children}) {
  const { login } = useSessionStore();
  const navigate = useNavigate()

  useEffect(() => {
    if(!login) navigate("/login")
  },[login])

  return (login)
  ? children
  : <Navigate to="/login" />
}

PrivateRoutes.propTypes = {
  children: PropTypes.object
}